<template>
    <div class="detail">
        <div class="title">
            任務事項
        </div>
        <div class="item" v-if="hasReservedAt">
            <div class="span">{{ isSetMode ? '預約時間' : '任務開始時間' }}</div>
            <date-time-select v-model="reservedAt" :is-set-mode="isSetMode"/>
        </div>
<!--        <div class="item" v-show="cartProductPrice > 0">-->
<!--            <div class="span">代付金額</div>-->
<!--            <div class="input expected" @click.stop="showExpected = true">-->
<!--                購物車＄ {{ cartProductPrice }}<span>&nbsp;+ 其他$ {{ cart.expected_price || 0 }}</span>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="item" v-show="cartProductPrice === 0">-->
<!--            <div class="span">代付金額</div>-->
<!--            <div class="input" @click.stop="focusExpected">-->
<!--                <span v-show="!isNaN(expectedPrice)">$</span><input :style="expectedInput" type="number" v-model="expectedPrice" @keyup.enter="$event.target.blur()" placeholder="商品總費用約 " ref="expected"><span v-show="isNaN(expectedPrice)">$0</span>-->
<!--            </div>-->
<!--        </div>-->
        <div class="item">
            <div class="span">急件費用</div>
            <div class="input" @click="showAddTip = true" :class="{placeholder: ! cart.tip_price}">
                {{ cart.tip_price ? '$ ' + cart.tip_price : '可加速任務執行' }}
            </div>
        </div>
        <div class="item">
            <div class="span">優惠折扣</div>
            <div v-show="isLogin" class="input" @click="showCoupon = true" :class="{placeholder: ! cartCoupon}">{{ cartCoupon ? '折扣 $' + cartCoupon.value : '要用優惠碼嗎？' }}</div>
            <div v-show="!isLogin" class="input placeholder" @click="goToLogin">請先登入使用優惠代碼</div>
        </div>
        <div class="item">
            <div class="span">無接觸配送</div>
            <p-switch v-model="noTouch" :enable="!forceNoTouch"/>
        </div>
        <div class="item">
            <div class="span">指定騎士</div>
            <div v-show="isLogin" class="input" @click="gotToDesignate" :class="{placeholder: ! cart.confirmDriver}">{{ cart.confirmDriver ? `#${cart.confirmDriver.knight_id} ${cart.confirmDriver.name}` : '可以指定特定的騎士' }}</div>
            <div v-show="!isLogin" class="input placeholder" @click="goToLogin">請先登入使用指定功能</div>
        </div>
        <add-tip v-if="showAddTip" @onCancel="showAddTip = false" @onDone="setTip" :default-tip="cart.tip_price || 0" :can-cancel="true"/>
        <set-coupon v-if="showCoupon" :coupon="cartCoupon" @onDone="setCoupon" @onCancel="showCoupon = false"/>
        <set-expected-price v-if="showExpected" @onCancel="showExpected = false" @onDone="showExpected = false"/>
    </div>
</template>

<script>
    import AddTip from './AddTip';
    import SetCoupon from './SetCoupon';
    import SetExpectedPrice from "./SetExpectedPrice";
    import { mapGetters, mapActions } from 'vuex';
    import moment from 'moment';
    import DateTimeSelect from '../DateTimeSelect';
    import PSwitch from '../Switch'

    export default {
        name: 'OrderDetail',
        props: {
            hasReservedAt: {
                default: true,
            }
        },
        components: {
            'add-tip': AddTip,
            'set-coupon': SetCoupon,
            'set-expected-price': SetExpectedPrice,
            'date-time-select': DateTimeSelect,
            'p-switch': PSwitch,
        },
        data() {
            return {
                showAddTip: false,
                showOrderTime: false,
                showCoupon: false,
                isSetMode: false,
                showExpected: false,
            }
        },
        computed: {
            expectedInput() {
                let width = (String(this.expectedPrice).length / 1.76) + 'em';
                if (isNaN(this.expectedPrice)) {
                    width = '100%';
                }

                return {
                    width: width,
                };
            },
            expectedPrice: {
                get() {
                    return parseInt(this.cart.expected_price);
                },
                set(price) {
                    this.setCartData({
                        value: Math.max(parseInt(price), 0),
                        key: 'expected_price'
                    });
                }
            },
            reservedAt: {
                get() {
                    if (!moment().isBefore(moment(this.cart.reserved_at))) {
                        return null;
                    }

                    return this.cart.reserved_at;
                },
                set(dateTime) {
                    this.setCartData({
                        value: dateTime,
                        key: 'reserved_at'
                    });
                }
            },
            noTouch: {
                get() {
                    return Boolean(this.cart.no_touch) || Boolean(this.forceNoTouch);
                },
                set(val) {
                    this.setCartData({
                        value: val ? 1 : 0,
                        key: 'no_touch'
                    })
                }
            },
            ...mapGetters(['cartCoupon', 'cart', 'isLogin', 'cartProductPrice', 'forceNoTouch'])
        },
        methods: {
            goToLogin() {
                this.$router.replace({
                   name: 'login',
                   query: {
                       ot: this.$route.name
                   }
                });
            },
            gotToDesignate() {
                this.setSelectedDriver();
                this.$router.push({
                    name: 'designate',
                    params: {
                        type: this.$route.name
                    }
                });
            },
            focusExpected() {
                this.$refs.expected.focus();
            },
            setTip(tip) {
                this.showAddTip = false;

                this.setCartData({
                    value: tip,
                    key: 'tip_price'
                });
            },
            setTime(day, time) {
                this.showOrderTime = false;
                if (! day) {
                    return;
                }

                if (time === 'now') {
                    this.setCartData({
                        value: null,
                        key: 'reserved_at'
                    });
                    this.timeTitle = '馬上出發';
                    return ;
                }

                this.timeTitle = `${day.value} ${time}`;
                this.setCartData({
                    value: `${day.date} ${time}:00`,
                    key: 'reserved_at'
                });
            },
            setCoupon(coupon) {
                this.showCoupon = false;

                this.setCartCoupon(coupon);
            },
            ...mapActions(['setCartCoupon', 'setCartData', 'setSelectedDriver'])
        },
        created() {
            if (this.cart.reserved_at) {
                this.timeTitle = moment(this.cart.reserved_at).format('MM/DD HH:mm')
            }

            this.isSetMode = this.$route.name === 'set';
        }
    };
</script>

<style lang="scss" scoped>
    .detail {
        padding: 25px;

        .title {
            color: rgba(0,0,0,1);
            font-size: 18px;
            font-weight: 500;
            line-height: 25px;
            text-align: left;
        }

        .item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: rgba(74,74,74,1);
            font-size: 14px;
            line-height: 20px;
            text-align: left;
            padding: 13px 0;
            border-bottom: solid 1px rgba(221,221,221,1);

            .span {
                width: 90px;
            }

            .input {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: calc(100% - 90px);
                text-align: right;
                font-size: 14px;
                line-height: 20px;
                color: #339933;
                cursor: pointer;

                &.placeholder{
                    color: rgba(155,155,155,1);
                }

                input {
                    text-align: right;
                    width: 100%;
                    border: none;
                    font-size: 14px !important;
                    margin-right: 0;
                    padding-right: 0;
                    -moz-appearance: textfield;
                    color: #339933;

                    &::placeholder {
                        color: rgba(155, 155, 155, 1);
                    }

                    &::-webkit-outer-spin-button {
                        -webkit-appearance: none !important;
                    }

                    &::-webkit-inner-spin-button {
                        -webkit-appearance: none !important;
                    }
                }

                &.expected {
                    color: #4A4A4A;

                    span {
                        color: #339933;
                    }
                }
            }
        }
    }
</style>
